import Language from './Language';
import LanguageDiscussionModal from './LanguageDiscussionModal';
import LanguageDropdown from './LanguageDropdown';

export const components = {
  Language,
  LanguageDiscussionModal,
  LanguageDropdown,
};
